import { create } from "zustand";

export interface CourseIngestResult {
  textbookId: string;
  pdfUri: string;
}

interface CourseIngestState {
  textbookId: string | null;
  pdfUri: string | null;
  /** Optional LMS course id from lms_ingestion step (fallback for cover upload). */
  courseId: string | null;
  setIngestResult: (result: CourseIngestResult) => void;
  setCourseId: (courseId: string | null) => void;
  clearIngest: () => void;
}

export const useCourseIngestStore = create<CourseIngestState>((set) => ({
  textbookId: null,
  pdfUri: null,
  courseId: null,
  setIngestResult: ({ textbookId, pdfUri }) =>
    set({ textbookId, pdfUri }),
  setCourseId: (courseId) => set({ courseId }),
  clearIngest: () =>
    set({ textbookId: null, pdfUri: null, courseId: null }),
}));
